import { combineReducers } from 'redux';
import InspectionsReducer from './inspections';
import InspectionDetailReducer from './inspection';
import UIReducer from './ui'
import AuthReducer from './auth'


export default combineReducers({
	InspectionsReducer,
	InspectionDetailReducer,
	UIReducer,
	AuthReducer
});



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js